/* ═══════════════════════════════════════════════════════════════════
   TIFFANYA — NOTES « Fits: » · SYSTÈME STANDARD (Lingerie Sets · Bodysuits)
   ───────────────────────────────────────────────────────────────────
   SOURCE UNIQUE des données « Fits: » du système standard.

   Deux consommateurs, un seul fichier :
     • la fiche produit  -> snippets/tf-fits-standard-page.liquid
     • le quickview      -> layout/theme.liquid (module qvUpdateFits)

   RÈGLE MÉTIER conservée telle quelle : on n'affiche « Fits: » QUE si
   les DEUX sélecteurs (« Bra Size » ET « Thong & Garter Size ») sont
   présents. Un produit vendu en taille unique n'affiche rien —
   volontairement, pas de recommandation partielle.

   v2 (sept. 2026)
     • Tables US/CA corrigées : UK DD = US DD, UK E = US DDD,
       UK F = US DDDD, UK FF = US H (elles étaient décalées d'un bonnet).
     • Nouveaux helpers partagés par la fiche produit ET le quickview :
         TF_FITS_STD.productSizes(scope) -> tailles réellement vendues
         TF_FITS_STD.chartFilter(root, scope) -> masque les lignes du
         tableau qui n'existent pas sur ce produit (ex. XXL sur un set
         XS–XL), aligne le libellé (XXL / 2XL) sur celui du produit et
         ajoute une note « voir Curvy Fits ».
   ═══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  if (window.TF_FITS_STD) return;   // chargé une seule fois

  var BRA_OPTION_NAME = 'Bra Size';
  var BOTTOM_OPTION_NAME = 'Thong & Garter Size';

  var BRA_STANDARD = {
    'UK': { 'XS':'30A, 32A, 34A, 30B, 32B', 'S':'38AA, 36A, 34B, 30C, 32C', 'M':'38A, 36B, 34C, 32D, 30DD', 'L':'40A, 38B, 36C, 34D, 32DD', 'XL':'40B, 38C, 36D, 34DD, 32E' },
    'US': { 'XS':'30A, 32A, 34A, 30B, 32B', 'S':'38AA, 36A, 34B, 30C, 32C', 'M':'38A, 36B, 34C, 32D, 30DD', 'L':'40A, 38B, 36C, 34D, 32DD', 'XL':'40B, 38C, 36D, 34DD, 32DDD' },
    'EU': { 'XS':'65A, 70A, 75A, 65B, 70B', 'S':'85AA, 80A, 75B, 65C, 70C', 'M':'85A, 80B, 75C, 70D, 65E', 'L':'90A, 85B, 80C, 75D, 70E', 'XL':'90B, 85C, 80D, 75E, 70F' }
  };
  var BOTTOM_MEASURE_STANDARD = {
    'XS':'23–26" waist, 32–35" hips', 'S':'25–28" waist, 34–37" hips', 'M':'27–31" waist, 36–40" hips',
    'L':'30–33" waist, 39–42" hips', 'XL':'32–35" waist, 41–44" hips'
  };
  var BOTTOM_DRESS_STANDARD = {
    'UK': { 'XS':'4–6', 'S':'6–8', 'M':'8–10', 'L':'10–12', 'XL':'12–14' },
    'US': { 'XS':'0–2', 'S':'2–4', 'M':'4–6', 'L':'6–8', 'XL':'8–10' },
    'EU': { 'XS':'32–34','S':'34–36','M':'36–38','L':'38–40','XL':'40–42' }
  };

  // ── PLUS SIZE (fourchette, charte groupée) — relais pour 2XL→6XL ──
  var BRA_MEASURE_PLUS = {
    '2XL':'40–44" bust', '3XL':'44–48" bust', '4XL':'44–48" bust', '5XL':'48–52" bust', '6XL':'48–52" bust'
  };
  var BOTTOM_MEASURE_PLUS = {
    '2XL':'42–46" hips', '3XL':'46–50" hips', '4XL':'46–50" hips', '5XL':'50–54" hips', '6XL':'50–54" hips'
  };
  var DRESS_SIZE_PLUS = {
    'UK': { '2XL':'16–18','3XL':'20–22','4XL':'20–22','5XL':'24–26','6XL':'24–26' },
    'US': { '2XL':'12–14','3XL':'16–18','4XL':'16–18','5XL':'20–22','6XL':'20–22' },
    'EU': { '2XL':'44–46','3XL':'48–50','4XL':'48–50','5XL':'52–54','6XL':'52–54' }
  };
  /* ─────────────────────────────────────────────────────────────────
     Calcul du texte — logique reprise telle quelle de la fiche produit.
     ───────────────────────────────────────────────────────────────── */
  function braFitText(size, system) {
    var std = BRA_STANDARD[system] && BRA_STANDARD[system][size];
    if (std) return 'Fits: ' + std;
    var measure = BRA_MEASURE_PLUS[size];
    return measure ? ('Fits: ' + measure) : '';
  }

  function bottomFitText(size, system, label) {
    var stdMeasure = BOTTOM_MEASURE_STANDARD[size];
    if (stdMeasure) {
      var stdDress = BOTTOM_DRESS_STANDARD[system] && BOTTOM_DRESS_STANDARD[system][size];
      return stdDress ? ('Fits: ' + stdMeasure + ' · ' + label + ' ' + stdDress) : ('Fits: ' + stdMeasure);
    }
    var plusMeasure = BOTTOM_MEASURE_PLUS[size];
    if (plusMeasure) {
      var plusDress = DRESS_SIZE_PLUS[system] && DRESS_SIZE_PLUS[system][size];
      return plusDress ? ('Fits: ' + plusMeasure + ' · ' + label + ' ' + plusDress) : ('Fits: ' + plusMeasure);
    }
    return '';
  }

  /* ─────────────────────────────────────────────────────────────────
     DOM
     ───────────────────────────────────────────────────────────────── */
  var QV_SELECTOR = '.tf-qv-root,[data-quickview-form-area],[data-quickview-modal],.quickview__modal';

  function inQuickview(el) {
    return !!(el && el.closest && el.closest(QV_SELECTOR));
  }

  /* Sans portée imposée on travaille sur la page SEULEMENT : sinon la
     fiche produit irait écrire ses propres notes dans le quickview
     ouvert par-dessus (mauvais produit, mauvaises tailles). */
  function wrapperByLabel(scope, name) {
    var sel = '.selector-wrapper[data-select-label="' + name + '"]';
    if (scope && scope !== document) return scope.querySelector(sel);
    var all = document.querySelectorAll(sel);
    for (var i = 0; i < all.length; i++) if (!inQuickview(all[i])) return all[i];
    return null;
  }

  /* Même chose, mais avec un test sur le libellé (minuscules). */
  function wrapperByTest(scope, test) {
    var all = (scope && scope !== document ? scope : document).querySelectorAll('.selector-wrapper[data-select-label]');
    for (var i = 0; i < all.length; i++) {
      var w = all[i];
      if ((!scope || scope === document) && inQuickview(w)) continue;
      if (test((w.getAttribute('data-select-label') || '').trim().toLowerCase())) return w;
    }
    return null;
  }

  function checkedValue(wrapper) {
    if (!wrapper) return null;
    var checked = wrapper.querySelector('input[name^="options["]:checked');
    if (checked) return checked.value;
    var sel = wrapper.querySelector('select');
    return sel ? sel.value : null;
  }

  function ensureNote(wrapper) {
    var note = wrapper.querySelector('.tf-fit-note');
    if (!note) {
      note = document.createElement('p');
      note.className = 'tf-fit-note';
      // Protège CET élément du morph Alpine, sans figer tout le bloc
      // variant-selectors (ça casserait la synchro panier).
      note.setAttribute('data-morph-skip', '');
      var fieldset = wrapper.querySelector('fieldset');
      (fieldset || wrapper).appendChild(note);
    }
    return note;
  }

  function clearNote(wrapper) {
    var note = wrapper && wrapper.querySelector('.tf-fit-note');
    if (note) note.textContent = '';
  }

  function normSystem(s) {
    return (s === 'US' || s === 'EU') ? s : 'UK';
  }

  /* ─────────────────────────────────────────────────────────────────
     API publique
       paint(scope, system, label)
         scope  : élément conteneur (formulaire du quickview) ou null
                  pour la fiche produit
         system : 'UK' | 'US' | 'EU'
         label  : 'UK' | 'US' | 'CA' | 'EU'  (libellé affiché)
     ───────────────────────────────────────────────────────────────── */
  function paint(scope, system, label) {
    var bra = wrapperByLabel(scope, BRA_OPTION_NAME);
    var bottom = wrapperByLabel(scope, BOTTOM_OPTION_NAME);

    // RÈGLE CLÉ : les deux sélecteurs, ou rien.
    if (!bra || !bottom) {
      clearNote(bra); clearNote(bottom);
      return false;
    }

    var sys = normSystem(system);
    var lab = label || sys;

    var bv = checkedValue(bra);
    ensureNote(bra).textContent = bv ? braFitText(bv, sys) : '';

    var ov = checkedValue(bottom);
    ensureNote(bottom).textContent = ov ? bottomFitText(ov, sys, lab) : '';
    return true;
  }

  /* ─────────────────────────────────────────────────────────────────
     TAILLES RÉELLEMENT VENDUES SUR LE PRODUIT
     ───────────────────────────────────────────────────────────────────
     Lues sur le formulaire (les pastilles du thème). Le thème pose la
     classe « sold-out » sur une variante épuisée et « unavailable » sur
     une combinaison inexistante : on remonte les deux.

     canon() : « XXL » et « 2XL » désignent la même taille (le tableau
     dit XXL, les bodysuits sont vendus en 2XL).
     ───────────────────────────────────────────────────────────────── */
  function canon(s) {
    var v = String(s || '').replace(/\s+/g, '').toUpperCase();
    if (v === '2XL') return 'XXL';
    return v;
  }

  function sizesFromWrapper(wrapper) {
    if (!wrapper) return null;
    var out = [];
    wrapper.querySelectorAll('input[name^="options["]').forEach(function (i) {
      out.push({
        value: String(i.value).trim(),
        soldOut: i.classList.contains('sold-out') || i.classList.contains('unavailable') || i.disabled
      });
    });
    if (!out.length) {
      var sel = wrapper.querySelector('select');
      if (sel) {
        Array.prototype.forEach.call(sel.options, function (o) {
          if (o.value) out.push({ value: String(o.value).trim(), soldOut: !!o.disabled });
        });
      }
    }
    return out.length ? out : null;
  }

  function isBottomLabel(l) {
    return l.indexOf('thong') > -1 || l.indexOf('garter') > -1 || l.indexOf('panty') > -1 || l.indexOf('bottom') > -1;
  }

  /* Renvoie { dual, bra:[...], bottom:[...], one:[...] } ou null si
     aucun sélecteur de taille n'a été trouvé (on ne filtre alors rien). */
  function productSizes(scope) {
    var braW = wrapperByLabel(scope, BRA_OPTION_NAME) || wrapperByTest(scope, function (l) { return l === 'bra size'; });
    var botW = wrapperByLabel(scope, BOTTOM_OPTION_NAME) || wrapperByTest(scope, isBottomLabel);
    var bra = sizesFromWrapper(braW);
    var bottom = sizesFromWrapper(botW);
    if (bra && bottom) return { dual: true, bra: bra, bottom: bottom, one: null };

    var oneW = wrapperByTest(scope, function (l) { return l === 'size'; }) ||
               wrapperByTest(scope, function (l) { return l.indexOf('size') > -1 && !isBottomLabel(l) && l !== 'bra size'; }) ||
               braW;
    var one = sizesFromWrapper(oneW);
    if (!one) return null;
    return { dual: false, bra: null, bottom: null, one: one };
  }

  /* Cherche une taille (XS…XXL) dans une liste de tailles produit.
     Renvoie { ok, soldOut, label } — label = libellé exact du produit. */
  function findSize(list, size) {
    if (!list) return { ok: false, soldOut: false, label: String(size) };
    var key = canon(size);
    for (var i = 0; i < list.length; i++) {
      if (canon(list[i].value) === key) {
        return { ok: true, soldOut: !!list[i].soldOut, label: list[i].value };
      }
    }
    return { ok: false, soldOut: false, label: String(size) };
  }

  /* ─────────────────────────────────────────────────────────────────
     FILTRAGE DU TABLEAU DE LA MODALE
       root  : l'overlay .tf2-overlay (page produit OU quickview)
       scope : formulaire du quickview, ou null pour la fiche produit
     ─────────────────────────────────────────────────────────────────
     1re table = Bra Size, 2e table = Thong & Garter / Panty.
     Les lignes dont la taille n'est pas vendue sur CE produit sont
     masquées ; le libellé XXL est remplacé par celui du produit (2XL)
     quand il diffère ; une note renvoie vers Curvy Fits si des tailles
     plus grandes ont été masquées.
     ───────────────────────────────────────────────────────────────── */
  var LADDER = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];

  function applyToTable(table, list, curvyUrl) {
    if (!table || !list || !list.length) return;
    var hiddenAbove = false, hidden = false, shown = [];
    table.querySelectorAll('tbody tr').forEach(function (tr) {
      var lab = tr.querySelector('.tf2-lab');
      if (!lab) return;
      var rowSize = lab.textContent.trim();
      var found = findSize(list, rowSize);
      if (!found.ok) {
        tr.style.display = 'none';
        hidden = true;
        if (LADDER.indexOf(canon(rowSize)) > LADDER.indexOf(canon(shown[shown.length - 1] || 'XS'))) hiddenAbove = true;
      } else {
        tr.style.display = '';
        if (found.label !== rowSize) lab.textContent = found.label;
        shown.push(found.label);
      }
    });
    var wrap = table.closest('.tf2-twrap') || table;
    var note = wrap.nextElementSibling && wrap.nextElementSibling.classList && wrap.nextElementSibling.classList.contains('tf2-foot')
      ? wrap.nextElementSibling : null;
    if (hidden && shown.length) {
      if (!note) {
        note = document.createElement('p');
        note.className = 'tf2-foot';
        wrap.insertAdjacentElement('afterend', note);
      }
      var range = shown.length > 1 ? (shown[0] + '–' + shown[shown.length - 1]) : shown[0];
      note.innerHTML = 'This style comes in <strong>' + range + '</strong>.' +
        (hiddenAbove ? ' Need a larger size? See our <a href="' + curvyUrl + '">Curvy Fits</a> collection (L–4XL).' : '');
    } else if (note) {
      note.remove();
    }
  }

  function chartFilter(root, scope) {
    if (!root) return false;
    var ps = productSizes(scope);
    if (!ps) return false;
    var curvyUrl = root.getAttribute('data-curvy-url') || '/collections/plus-size';
    var tables = root.querySelectorAll('table.tf2-table');
    if (!tables.length) return false;
    applyToTable(tables[0], ps.dual ? ps.bra : ps.one, curvyUrl);
    if (tables[1]) applyToTable(tables[1], ps.dual ? ps.bottom : ps.one, curvyUrl);
    root.setAttribute('data-tf-filtered', '');
    return true;
  }

  window.TF_FITS_STD = {
    paint: paint,
    braText: braFitText,
    bottomText: bottomFitText,
    productSizes: productSizes,
    findSize: findSize,
    canon: canon,
    chartFilter: chartFilter
  };
})();
